module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Tooltip ใช้แสดง Content ที่ซ่อนไว้ด้วยการ Hover Element ที่ต้องการ\n        เพื่อแสดงข้อมูลที่เกี่ยวข้องกับ Element โดย Content จะเป็นได้เพียง Text\n        ที่ระบุใน Attribute: data-tooltip เท่านั้น\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentProgress'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Progress\n          ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#component-tooltip"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Tooltip\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class ที่เกี่ยวข้อง")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-tooltip")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-tooltip")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Position: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-top")]), _vm._v(" (default),\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-right")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-left")]), _vm._v(",\n                "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-bottom")]), _vm._v(",\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Top -->\n<div class=\"bio-tooltip\" data-tooltip=\"Hello there!!!\">\n  Hover ME!! Top\n</div>\n\n<!-- Left -->\n<div class=\"bio-tooltip -left\" data-tooltip=\"Hello there!!!\">\n  Hover ME!! Left\n</div>\n\n<!-- Right -->\n<div class=\"bio-tooltip -right\" data-tooltip=\"Hello there!!!\">\n  Hover ME!! Right\n</div>\n\n<!-- Bottom -->\n<div class=\"bio-tooltip -bottom\" data-tooltip=\"Hello there!!!\">\n  Hover ME!! Bottom\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px _tal-ct"
  }, [_c('div', {
    staticClass: "bio-tooltip _dp-ilb _mgbt-16px",
    attrs: {
      "data-tooltip": "Hello there!!!"
    }
  }, [_vm._v("Hover ME!! Top")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bio-tooltip -left _dp-ilb _mgbt-16px",
    attrs: {
      "data-tooltip": "Hello there!!!"
    }
  }, [_vm._v("Hover ME!! Left")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bio-tooltip -right _dp-ilb _mgbt-16px",
    attrs: {
      "data-tooltip": "Hello there!!!"
    }
  }, [_vm._v("Hover ME!! Right")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bio-tooltip -bottom _dp-ilb",
    attrs: {
      "data-tooltip": "Hello there!!!"
    }
  }, [_vm._v("Hover ME!! Bottom")]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน รูปแบบอื่น")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-tooltip\" data-tooltip=\"I'm a button\">\n  <div class=\"bio-button\">Button</div>\n</div>\n\n<div class=\"bio-tooltip -right\" data-tooltip=\"I'm a Link\">\n  <a class=\"bio-link -fancy\">Link</a>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-tooltip _dp-ilb",
    attrs: {
      "data-tooltip": "I'm a button"
    }
  }, [_c('div', {
    staticClass: "bio-button"
  }, [_vm._v("Button")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-tooltip -right _dp-ilb",
    attrs: {
      "data-tooltip": "I'm a Link"
    }
  }, [_c('a', {
    staticClass: "bio-link -fancy"
  }, [_vm._v("Link")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2da39918","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/ComponentTooltip.vue
// module id = 118
// module chunks = 0